import { render, staticRenderFns } from "./GeneralJournalSummary.vue?vue&type=template&id=0f43914e&scoped=true"
import script from "./GeneralJournalSummary.vue?vue&type=script&lang=js"
export * from "./GeneralJournalSummary.vue?vue&type=script&lang=js"
import style0 from "./GeneralJournalSummary.vue?vue&type=style&index=0&id=0f43914e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43914e",
  null
  
)

export default component.exports